import Vue from 'vue'
import {Pagination, Collapse, CollapseItem, Input} from 'element-ui'
Vue.use(Pagination).use(Collapse).use(CollapseItem).use(Input);
